import React, { useEffect } from 'react';
import { Result } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const ServerDetector = (props) => {
  const { t } = useTranslation();

  const { socketState } = useSelector((state) => state);

  useEffect(() => {
    const handleOffline = () => {
      localStorage.setItem('pageBeforeOffline', window.location?.pathname);
    };

    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <>
      {/* {socketState === -1 ? (
        <Result
          status="500"
          title="500"
          subTitle={t('The server is under maintenance, please try again later!')}
          extra={<Link to="/">{t('Back DashBoard')}</Link>}
        />
      ) : ( */}
      {props.children}
      {/* )} */}
    </>
  );
};

export default ServerDetector;
